import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, ArrowLeft, Search } from 'lucide-react';
import { navigateBackWithFallback } from '@/lib/utils/navigation';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center p-6 text-center space-y-6">
      <div className="space-y-4 max-w-md">
        <h1 className="text-6xl font-bold text-primary">404</h1>
        <h2 className="text-2xl font-semibold">Page Not Found</h2>
        <p className="text-muted-foreground">
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row gap-4">
        <Button asChild size="lg">
          <Link to="/">
            <Home className="mr-2 h-4 w-4" />
            Back to Home
          </Link>
        </Button>
        <Button asChild variant="outline" size="lg">
          <Link to="/contact">
            <Search className="mr-2 h-4 w-4" />
            Get Help
          </Link>
        </Button>
      </div>

      <div className="mt-12 space-y-2">
        <p className="text-sm text-muted-foreground">
          Looking for something else?
        </p>
        <div className="flex flex-wrap justify-center gap-2">
          <Button asChild variant="ghost" size="sm">
            <Link to="/events">Events</Link>
          </Button>
          <Button asChild variant="ghost" size="sm">
            <Link to="/media">Media</Link>
          </Button>
          <Button asChild variant="ghost" size="sm">
            <Link to="/resources">Resources</Link>
          </Button>
          <Button asChild variant="ghost" size="sm">
            <Link to="/about">About Us</Link>
          </Button>
          <Button asChild variant="ghost" size="sm">
            <Link to="/contact">Contact</Link>
          </Button>
        </div>
      </div>

      <div className="mt-8">
        <Button
          variant="link"
          size="sm"
          onClick={() => navigateBackWithFallback(navigate, '/')}
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Go back
        </Button>
      </div>
    </div>
  );
}
